import { render, staticRenderFns } from "./Cifuri.vue?vue&type=template&id=fc41856a"
import script from "./Cifuri.vue?vue&type=script&lang=js"
export * from "./Cifuri.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports